<template>
  <div>
    <PageAllow controller="Purchases" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <!-- <v-sheet
          id="fix-header"
          v-resize="$mainResizer"
          :class="
            ($vuetify.rtl ? 'fix-header-rtl ' : 'fix-header ') +
            (mainContentScrolled
              ? 'elevation-2'
              : 'transparent-background-color')
          "
        > -->
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
               <!-- 批量发货 -->
              <v-btn
                v-if="
                  accountUser &&
                  accountUser.supplier &&
                  accountUser.supplier.delivery_flg == 1
                "
                small
                color="orange"
                dark
                class="ms-1"
                @click="batchDeliveryDialog = true"
              >
                {{ $t("Delivery.Fields.batch_delivery") }}
              </v-btn>
              <!-- 批量打印 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="BatchPrint()"
              >
                {{ $t("Delivery.Fields.batch_print") }}
              </v-btn>
              <!-- 批量云打印 -->
              <v-btn
                v-if="accountUser && accountUser.supplier.cloud_print_flg"
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="BatchCloudPrint()"
              >
                {{ $t("Delivery.Fields.batch_cloud_print") }}
              </v-btn>
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                @click.stop="batchExports()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Export.batchExport") }}
              </v-btn>
              <!-- 批量导入 -->
              <v-btn
                v-if="
                  accountUser &&
                  accountUser.supplier &&
                  accountUser.supplier.delivery_flg
                "
                small
                color="print"
                dark
                @click.stop="importDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.batchImport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="purchase_code"
                    v-model="options.purchase_code"
                    @text="orderCodeKeyword = $event"
                    :label="$t('Delivery.Fields.purchase_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- 客户名称 -->
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="Keyword = $event"
                    :label="
                      $t('Delivery.Fields.account_name', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 采购单来源 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherPurchaseOriginFlgs v-model="origin_flgs" />
                </v-col>
                <!-- 发货状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.delivery_flgs"
                    :label="$t('Delivery.Fields.status')"
                    :items="$consts.deliverFlgs"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.check_flgs"
                    :label="$t('Delivery.Fields.check_status')"
                    :items="$consts.checkFlgs"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.supplier_examine_status"
                    :label="$t('Delivery.Fields.supplier_examine_status')"
                    :items="$consts.supplierExamineStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <!-- 表格 -->
      <div class="mx-4 mb-4">
        <!-- :style="'padding-top: ' + fixHeaderHeightInPx + 'px'" -->
        <v-data-table
          :headers="headers"
          :items="purchases"
          :options.sync="options"
          :loading="loading"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          mobile-breakpoint="800"
          multi-sort
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <!-- 按钮  -->
          <template v-slot:item.actions="{ item }">
            <!-- 明细 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  :dark="detailMode"
                  color="info"
                  class="px-2 me-2"
                  :href="'/#/delivery/' + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.detail") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("Delivery.Fields.detail")])
              }}</span>
            </v-tooltip>
            <!-- 查收 -->
            <v-tooltip top v-if="item.actions.check">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="action"
                  class="px-2 me-2"
                  @click="check(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.check") }}
                </v-btn>
              </template>
              <span>{{ $t("Delivery.Fields.check") }}</span>
            </v-tooltip>
            <!-- 发货 -->
            <v-tooltip top v-if="item.actions.delivery">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="action"
                  class="px-2 me-2"
                  @click="delivery(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.delivery") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("Delivery.Fields.delivery")])
              }}</span>
            </v-tooltip>
            <!-- 物流 -->
            <v-tooltip
              top
              v-if="
                accountUser &&
                accountUser.supplier.delivery_flg == 1 &&
                (item.status != 4 || item.logistics_json)
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  :color="item.logistics_json ? 'orange' : 'primary'"
                  class="px-2 me-2"
                  @click.stop="
                    editLogisticAlert = true;
                    currentItem = item;
                  "
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.logistic") }}
                </v-btn>
              </template>
              <span>{{ $t("Delivery.Fields.logistic") }}</span>
            </v-tooltip>
            <!-- 打印 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="print"
                  class="px-2 me-2"
                  @click="Print(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.print") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("Delivery.Fields.print")])
              }}</span>
            </v-tooltip>
            <!-- 打印 -->
            <v-tooltip
              top
              v-if="accountUser && accountUser.supplier.cloud_print_flg"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="print"
                  class="px-2 me-2"
                  @click="cloudPrint(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.cloud_print") }}
                </v-btn>
              </template>
              <span>{{ $t("Delivery.Fields.cloud_print") }}</span>
            </v-tooltip>
            <!-- 导出 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="print"
                  class="px-2 me-2"
                  @click.stop="Exports(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("Delivery.Fields.export") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("Delivery.Fields.print")])
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.purchase_code="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.purchase_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>

          <template v-slot:item.expect_date="{ item }">
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.expect_date | formatTime }}
            </span>
          </template>

          <!-- 客户名称 -->
          <template v-slot:item.account_name="{ item }">
            <!-- <span class="text-no-wrap caption font-weight-bold" v-if="item.stock_order == null ">
                    {{ accountInfo?accountInfo.account_name:'' }}
                </span>
                <br v-if="item.stock_order == null "/> -->
            <!-- class="text-no-wrap caption secondary--text"
                    :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1' " -->
            <span v-if="item.stock_order == null">
              {{ item.stock.name }}
            </span>
            <span v-if="item.stock_order != null">
              {{ item.stock_order ? item.stock_order.shop.shop_name : "" }}
            </span>
          </template>

          <template v-slot:item.total="{ item }">
            <span v-if="item.delivery_flg == 0">
              {{ $t("Global.money") }}{{ item.total | formatMoney }}
            </span>
            <span v-if="item.delivery_flg == 1">
              {{ $t("Global.money")
              }}{{ item.delivery_total_price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.total_num="{ item }">
            <span v-if="item.delivery_flg == 0">
              {{ item.total_num | formatTwoDot }}
            </span>
            <span v-if="item.delivery_flg == 1">
              {{ item.delivery_total_num | formatTwoDot }}
            </span>
          </template>

          <!-- 状态 -->
          <template v-slot:item.delivery_flg="{ item }">
            <v-chip
              small
              label
              :color="item.delivery_flg | deliverFlgsColor"
              :text-color="item.delivery_flg | deliverFlgsTextColor"
            >
              {{ item.delivery_flg | deliverFlgsText }}
            </v-chip>
          </template>
          <template v-slot:item.examine_status="{ item }">
            <span v-if="item.origin_flg == '102'">
              <v-chip
                small
                label
                :color="
                  item.examine_code ? item.is_examined : 0 | examineStatusColor
                "
                :text-color="
                  item.examine_code
                    ? item.is_examined
                    : 0 | examineStatusTextColor
                "
              >
                {{
                  item.examine_code ? item.is_examined : 0 | examineStatusText
                }}
              </v-chip>
            </span>
            <span v-else>
              <v-chip
                small
                label
                :color="item.status == 4 ? 4 : 2 | purchaseStatusColor"
                :text-color="item.status == 4 ? 4 : 2 | purchaseStatusTextColor"
              >
                {{ item.status == 4 ? 4 : 2 | purchaseStatusText }}
              </v-chip>
            </span>
          </template>
          <template v-slot:item.check_flg="{ item }">
            <v-chip
              small
              label
              :color="item.check_flg | checkFlgsColor"
              :text-color="item.check_flg | checkFlgsTextColor"
            >
              {{ item.check_flg | checkFlgsText }}
            </v-chip>
          </template>
          <!-- 发货单来源 -->
          <template v-slot:item.origin_flg="{ item }">
            <v-chip
              small
              label
              :color="item.origin_flg != 102 ? 101 : 102 | originFlgsColor"
              :text-color="
                item.origin_flg != 102 ? 101 : 102 | originFlgsTextColor
              "
            >
              {{ item.origin_flg != 102 ? 101 : 102 | originFlgsText }}
            </v-chip>
          </template>
          <!-- hope_delivery_date -->
          <template v-slot:item.hope_delivery_date="{ item }">
            {{ item.hope_delivery_date | formatDate }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <ImportExcelAlert
      v-model="importDialog"
      :objName="$t('Delivery.ObjectName')"
      @import="
        importFile = $event;
        importExcel();
      "
    />
    <EditLogisticAlert
      v-model="editLogisticAlert"
      :purchases="currentItem"
      @editLogistic="getPurchasesFromAPI()"
    />

     <!-- 批量发货 -->
    <DialogAlert
      v-model="batchDeliveryDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Delivery.messages.batchDeliveryAlert')"
      persistent
      useConfirm
      @confirm="
        batchDeliveryDialog = false;
        batchDeliveryInfoDialog = true;
        batchDelivery(JSON.parse(JSON.stringify(options)));
      "
    />

    <BatchDeliveryInfoAlert
      v-model="batchDeliveryInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchDeliveryInfo"
      persistent
      :closable="errorCount > 0"
    />

  </div>
</template>


<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import Delivery from "@/api/delivery";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import EditLogisticAlert from "./plugins/EditLogisticAlert";
import SearcherPurchaseOriginFlgs from "@/components/plugins/SearcherPurchaseOriginFlgs";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchDeliveryInfoAlert from "./plugins/BatchDeliveryInfoAlert";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  origin_flgs: [],
  supplier_examine_status: [0, 1],
  expect_time_to: "",
  expect_time_from: "",
  purchase_code: "",
  keyword: "",
  delivery_flgs: [0, 1],
  check_flgs: [0, 1],
  status: [2, 3, 4],
};

export default {
  data: () => ({
    purchases: [],
    orderCodeKeyword: "",
    Keyword: "",
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    origin_flgs: [],
    loading: false,
    importFile: null,
    importDialog: false,
    currentItem: null,
    editLogisticAlert: false,
    errorCount: 0,
    successCount: 0,
    error_purchase_id: [],
    batchDeliveryDialog: false,
    batchDeliveryInfoDialog: false,
    batchDeliveryInfo: i18n.t("Delivery.messages.batchDeliveryInfo", [0, 0]),
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherKeyword,
    SearcherStatus,
    ImportExcelAlert,
    EditLogisticAlert,
    SearcherPurchaseOriginFlgs,
    DialogAlert,
    BatchDeliveryInfoAlert,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.delivery"),
        disabled: false,
        href: "/delivery",
      },
      {
        text: i18n.t("Nav.deliveryDetail"),
        disabled: true,
        href: "/delivery",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Delivery.Fields.created_time"),
      },
      {
        key: "expect",
        text: i18n.t("Delivery.Fields.expect_date"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("Delivery.Fields.purchase_code"),
          align: "start",
          sortable: false,
          value: "purchase_code",
        },
        {
          text: i18n.t("Delivery.Fields.account_name", [
            this.$consts.shopName(),
          ]),
          align: "start",
          sortable: false,
          value: "account_name",
        },
        {
          text: i18n.t("Delivery.Fields.expect_date"),
          align: "start",
          sortable: false,
          value: "hope_delivery_date",
        },
        {
          text: i18n.t("Delivery.Fields.origin_flg"),
          align: "start",
          sortable: false,
          value: "origin_flg",
        },
        {
          text: i18n.t("Delivery.Fields.number"),
          align: "end",
          sortable: false,
          value: "total_num",
        },
        {
          text: i18n.t("Delivery.Fields.total"),
          align: "end",
          sortable: false,
          value: "total",
        },
        {
          text: i18n.t("Delivery.Fields.check_status"),
          align: "start",
          sortable: false,
          value: "check_flg",
        },
        {
          text: i18n.t("Delivery.Fields.status"),
          align: "start",
          sortable: false,
          value: "delivery_flg",
        },
        {
          text: i18n.t("Delivery.Fields.examine_status"),
          align: "start",
          sortable: false,
          value: "examine_status",
        },
        // 操作
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    ...mapState([
      "accountInfo",
      "settings",
      "accountUser",
      "fixHeaderHeightInPx",
      "mainContentScrolled",
    ]),
  },

  mounted() {
    this.$commonUtils.loadOptions("delivery").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        purchase_code: this.orderCodeKeyword,
        keyword: this.Keyword,
      });
      this.getPurchasesFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getPurchasesFromAPI() {
      this.loading = true;
      //发货一览排除供应商自主采购单104
      Delivery.fetch(
        Object.assign({}, this.options, {
          origin_flgs:
            this.options.origin_flgs.length == 0
              ? [101, 102, 103, 201, 301]
              : this.options.origin_flgs,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchases = response.data.purchases;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },

    Print(e) {
      this.$router.push("/print/delivery-print/" + e);
    },
    cloudPrint(id) {
      //获取单据详情
      Delivery.print(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            let purchase = response.data.purchase;
            if (purchase.delivery_info)
              purchase.delivery_info = this.$printUtils.addCitiesName(
                purchase.delivery_info
              );
            purchase.purchase_details = purchase.purchase_details.map(
              (detail) => {
                if (detail.negotiate_price_flg == 1) {
                  // 显示后议价
                  // 单价
                  detail.price = this.$t(
                    "DeliveryDetail.Fields.negotiatePrices"
                  );
                  // 采购金额
                  detail.total = this.$t(
                    "DeliveryDetail.Fields.negotiatePrices"
                  );
                }
                return detail;
              }
            );
            CloudPrintTemplates.print({
              print_template_code: "supplierPurchase",
              object: purchase,
            });
          }
        }.bind(this)
      );
    },
    Exports(id) {
      Delivery.Exports(id);
    },
    batchExports() {
      let options = this.options;
      options.supplier_id = this.accountUser.supplier_id;
      Delivery.batchExports(
        Object.assign({}, options, {
          origin_flgs:
            options.origin_flgs.length == 0
              ? [101, 102, 103, 201, 301]
              : options.origin_flgs,
        })
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Delivery.imports(this.importFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Delivery.ObjectName")])
              );
              this.importDialog = false;
              this.getPurchasesFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    BatchPrint() {
      this.$router.push({
        path: "/print/batch-delivery-print",
        query: Object.assign({}, this.options, {
          origin_flgs:
            this.options.origin_flgs.length == 0
              ? [101, 102, 103, 201, 301]
              : this.options.origin_flgs,
        }),
      });
    },
    BatchCloudPrint() {
      //获取单据详情
      Delivery.batchPrint(
        Object.assign({}, this.options, {
          origin_flgs:
            this.options.origin_flgs.length == 0
              ? [101, 102, 103, 201, 301]
              : this.options.origin_flgs,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            let purchases = response.data.purchases;
            if (purchases) {
              purchases = purchases.map(
                function (purchase) {
                  purchase.purchase_details = purchase.purchase_details.map(
                    (detail) => {
                      if (detail.negotiate_price_flg == 1) {
                        // 显示后议价
                        // 单价
                        detail.price = this.$t(
                          "DeliveryDetail.Fields.negotiatePrices"
                        );
                        // 采购金额
                        detail.total = this.$t(
                          "DeliveryDetail.Fields.negotiatePrices"
                        );
                      }
                      return detail;
                    }
                  );
                  purchase.delivery_info = this.$printUtils.addCitiesName(
                    purchase.delivery_info
                  );
                  return purchase;
                }.bind(this)
              );
              CloudPrintTemplates.batchPrint({
                print_template_code: "supplierPurchase",
                objects: purchases,
              });
            }
          }
        }.bind(this)
      );
    },
    delivery(e) {
      this.$router.replace("/delivery/edit/" + e);
    },

    check(e) {
      Delivery.check(e).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getPurchasesFromAPI();
          }
        }.bind(this)
      );
    },
    batchDelivery(options) {
      if (this.error_purchase_id.length) {
        options.no_purchase_ids = this.error_purchase_id;
      }
      Delivery.batchDelivery(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.delivery_flg) {
              ++this.successCount;
            } else {
              this.error_purchase_id.push(response.data.purchase_id);
              ++this.errorCount;
              // this.batchApproveErrorData.push(response.data.data[0]);
              // this.batchApproveErrorDialog = true;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_purchase_id.push(response.data.purchase_id);
              ++this.errorCount;
              // if (response.data.error.code == "ERR668") {
              //   this.batchApproveErrorData.push(response.data.data[0]);
              //   this.batchApproveErrorDialog = true;
              // }
            } else {
              this.getPurchasesFromAPI();
              options = null;
              this.error_purchase_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.batchDeliveryInfoDialog = false;
            }
          }
          //实时计数
          this.batchDeliveryInfo = i18n.t("Delivery.messages.batchDeliveryInfo", [
            this.successCount,
            this.errorCount,
          ]);
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchDelivery(options);
          }
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "delivery-options",
          JSON.stringify(this.options)
        );
        this.getPurchasesFromAPI();
      },
    },
    origin_flgs: {
      deep: true,
      handler() {
        this.options.origin_flgs = [];
        if (this.origin_flgs.find((flgs) => flgs == 101)) {
          this.options.origin_flgs.push(101);
          this.options.origin_flgs.push(103);
          this.options.origin_flgs.push(201);
          this.options.origin_flgs.push(301);
        }
        if (this.origin_flgs.find((flgs) => flgs == 102)) {
          this.options.origin_flgs.push(102);
        }
      },
    },
  },
};
</script>

<style>
</style>